import { render, staticRenderFns } from "./UserTableItem.vue?vue&type=template&id=059b2493&"
import script from "./UserTableItem.vue?vue&type=script&lang=js&"
export * from "./UserTableItem.vue?vue&type=script&lang=js&"
import style0 from "./UserTableItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports